import { render, staticRenderFns } from "./CustomerManagement.vue?vue&type=template&id=541ca698&scoped=true&"
import script from "./CustomerManagement.vue?vue&type=script&lang=js&"
export * from "./CustomerManagement.vue?vue&type=script&lang=js&"
import style0 from "./CustomerManagement.vue?vue&type=style&index=0&id=541ca698&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541ca698",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
